import React, { createContext, memo, useContext } from 'react';

// Create a context for ListingPage
const ListingPageContext = createContext();

export const ListingPageContextProvider = memo(({ children, ...rest }) => (
  <ListingPageContext.Provider value={rest}>{children}</ListingPageContext.Provider>
));

// Custom hook to access Page context
export const useListingPageContext = () => {
  return useContext(ListingPageContext);
};
